var ConditionListsAgreement = function () {
    var $currentContext = $();

    var classMap = {
        text: ".js-condition-lists-agreement__text",
        messageTemplate: ".js-condition-lists-agreement__message-template",
        confirmButton: ".js-condition-lists-agreement__confirm-button",
        rejectButton: ".js-condition-lists-agreement__reject-button",
    };

    var $text, $messageTemplate, $confirmButton, $rejectButton;

    var conditions, onConfirm, onReject;

    this.setConditions = function (value) {
        conditions = value;
        return this;
    }

    this.setOnConfirm = function(value) {
        onConfirm = value;
        return this;
    }

    this.setOnReject = function (value) {
        onReject = value;
        return this;
    }

    this.render = function () {
        for(var condition of conditions.conditionLists) {
            var $message = $messageTemplate.clone();
            $message.html(condition.message);
            $text.append($message)
                .append("<hr>");
        }
    }

    function bindEvents() {
        $confirmButton.on("click", onConfirm);
        $rejectButton.on("click", onReject);
    }

    function parseContext() {
        $text = $(classMap.text, $currentContext);
        $messageTemplate = $(classMap.messageTemplate, $currentContext);
        $confirmButton = $(classMap.confirmButton, $currentContext);
        $rejectButton = $(classMap.rejectButton, $currentContext);
    }

    this.init = function (context) {
        $currentContext = context || $currentContext;

        parseContext();
        bindEvents();
    };

    this.dispose = function () {
        $confirmButton.off("click");
        $rejectButton.off("click");
        $text.html("");
        $text.append($messageTemplate);
    }
};

Object.defineProperty(ConditionListsAgreement, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-condition-lists-agreement"
});

module.exports = ConditionListsAgreement;
